"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _ItemCard = _interopRequireDefault(require("../ItemCard"));

var _helpers = require("./helpers");

var _helpers2 = require("../SupplierRow/helpers");

var _ATCButton = _interopRequireDefault(require("../ATCButton"));

var _styles = _interopRequireDefault(require("./styles"));

var DetailsContainer = _styles["default"].DetailsContainer,
    PunchOutView = _styles["default"].PunchOutView,
    Row = _styles["default"].Row,
    Column = _styles["default"].Column;

var ItemDetailsModal = function ItemDetailsModal(props) {
  var toggle = props.toggle,
      item = props.item,
      env = props.env,
      config = props.config,
      allItems = props.allItems,
      searchTerm = props.searchTerm,
      isAvailable = props.isAvailable,
      setCurItem = props.setCurItem,
      setToggle = props.setToggle;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      similarItems = _useState2[0],
      setSimilarItems = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      itemDetails = _useState4[0],
      setItemDetails = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      punchoutToggle = _useState6[0],
      setPunchoutToggle = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      punchoutOverlayUrl = _useState8[0],
      setPunchoutOverlayUrl = _useState8[1];

  (0, _react.useEffect)(function () {
    if (item && allItems) {
      setItemDetails(null);
      (0, _helpers.itemDetailsFunc)({
        env: env,
        item: item,
        setItemDetails: setItemDetails
      });
      (0, _helpers.filterSimilarItems)({
        origItem: item,
        allItems: allItems,
        isAvailable: isAvailable,
        searchTerm: searchTerm,
        setSimilarItems: setSimilarItems,
        filterItems: _helpers2.filterItems,
        config: config
      });
    }
  }, [allItems, item]);
  (0, _react.useEffect)(function () {
    setPunchoutToggle(punchoutOverlayUrl ? true : false);
  }, [punchoutOverlayUrl]);
  console.log(item.supplier);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    toggle: toggle,
    height: "43rem",
    width: "47rem",
    setToggle: setToggle,
    "data-aurora-automation": "item-details-modal",
    mattsStyle: true,
    containerClassName: "item-details-modal"
  }, item && /*#__PURE__*/_react["default"].createElement(DetailsContainer, null, /*#__PURE__*/_react["default"].createElement(Column, {
    flex: 1,
    className: "column-left"
  }, /*#__PURE__*/_react["default"].createElement(Row, {
    className: "item-details-row1"
  }, punchoutOverlayUrl && /*#__PURE__*/_react["default"].createElement(PunchOutView, {
    className: "fade-in"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'fal fa-times ' + 'matts-style',
    "data-scorpius-automation": 'popupcard-closeicon',
    onClick: function onClick() {
      return setPunchoutOverlayUrl();
    }
  }), /*#__PURE__*/_react["default"].createElement("iframe", {
    src: punchoutOverlayUrl
  })), /*#__PURE__*/_react["default"].createElement("img", {
    alt: "item-image",
    src: item.Image
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "item-name-container"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "item-name"
  }, item.Name), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tags-container",
    "data-aurora-automation": "store-item-tags"
  }, item.IsAvailable && /*#__PURE__*/_react["default"].createElement("p", {
    className: "tag available"
  }, "Available")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "item-punchout-container",
    onClick: function onClick(e) {
      if (!item.supplier.IsStaticCatalog) setPunchoutOverlayUrl("".concat(window.location.origin, "/product-view?supplier=").concat(item.supplier.Id, "&productId=").concat(item.SupplierPartNumber));
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "supplier-image",
    alt: "supplier-image",
    src: env.blobUrl + '/' + item.supplier.WideLogo
  }), !item.supplier.IsStaticCatalog && /*#__PURE__*/_react["default"].createElement("p", {
    className: "micro"
  }, "View website")), item.Availability && /*#__PURE__*/_react["default"].createElement("p", {
    className: "item-availability",
    "data-aurora-automation": "store-item-availability"
  }, item.Availability), /*#__PURE__*/_react["default"].createElement("div", {
    className: "price-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "item-price",
    "data-aurora-automation": "store-item-price"
  }, (0, _helpers2.parsePrice)(item.Price)), item.IsAvailable && /*#__PURE__*/_react["default"].createElement(_ATCButton["default"], {
    item: item,
    config: config,
    contractId: item.supplier.items.ContractId,
    env: env,
    height: "2rem",
    width: "7.5rem"
  })))), itemDetails ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-details fade-in"
  }, /*#__PURE__*/_react["default"].createElement(Row, {
    className: "product-description fade-in"
  }, /*#__PURE__*/_react["default"].createElement(Column, {
    width: "100%"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Product Details"), itemDetails.Description ? /*#__PURE__*/_react["default"].createElement("p", null, itemDetails.Description) : /*#__PURE__*/_react["default"].createElement("p", null, "Description is not available."))), /*#__PURE__*/_react["default"].createElement(Column, {
    className: "product-specs fade-in"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Product Specs"), itemDetails.SpecTable ? /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(Column, {
    className: "spec-keys table-column",
    flex: 1
  }, Object.keys(itemDetails.SpecTable).map(function (key, i) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      className: "lite",
      key: i
    }, key);
  })), /*#__PURE__*/_react["default"].createElement(Column, {
    className: "spec-values table-column",
    flex: 1
  }, Object.values(itemDetails.SpecTable).map(function (value, i) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: i
    }, value);
  }))) : /*#__PURE__*/_react["default"].createElement("p", null, "Product specs are not available"))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-details-loading fade-in"
  }, /*#__PURE__*/_react["default"].createElement(Row, {
    className: "product-description"
  }, /*#__PURE__*/_react["default"].createElement(Column, {
    flex: 1
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Product Details"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row-loading shine"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row-loading shine"
  }))), /*#__PURE__*/_react["default"].createElement(Column, {
    className: "product-specs"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Product Specs"), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(Column, {
    flex: 1
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row2-loading shine"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row2-loading shine"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row2-loading shine"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row2-loading shine"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row2-loading shine"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row2-loading shine"
  })))))), /*#__PURE__*/_react["default"].createElement(Column, {
    className: "related-items"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "similar-items-container"
  }, /*#__PURE__*/_react["default"].createElement("h5", null, "Similar Items"), similarItems && !_lodash["default"].isEmpty(similarItems) ? similarItems.map(function (simItem, i) {
    if (simItem.SupplierPartNumber !== item.SupplierPartNumber) return /*#__PURE__*/_react["default"].createElement(_ItemCard["default"], {
      item: simItem,
      key: i,
      config: config,
      contractId: simItem.supplier.items.ContractId,
      supplier: simItem.supplier,
      env: env,
      atcButton: false,
      tags: false,
      supplierLogo: true,
      setCurItem: setCurItem
    });
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "no-similar-items"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "no-items-img",
    src: env.blobUrl + '/procurement/stores/Narwhal.png'
  }), /*#__PURE__*/_react["default"].createElement("h5", null, "This must be one-of-a-kind, because we couldn\u2019t find any similar items!"))))));
};

var _default = ItemDetailsModal;
exports["default"] = _default;